import script from "./LabelRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelRequired.vue?vue&type=script&setup=true&lang=js"

import "./LabelRequired.vue?vue&type=style&index=0&id=62720e43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62720e43"]])

export default __exports__